import { useQuery } from '@tanstack/react-query';
import getAccountType from 'Api/live-account/getAccountType';
import getAccountTypeResponse from './model/response/getAccountTypeResponse';

const useGetAccountType = () => {
  return useQuery({
    queryKey: ['account-type'],
    queryFn: async () => {
      const response = await getAccountType();

      return getAccountTypeResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetAccountType;
